/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type DownSavingUpdateRequest = {
    downSavingId: string;
    shopId: string;
    startDate: string;
    endDate?: string;
    contractReferenceId?: string;
    customerFirstName: string;
    customerLastName: string;
    customerCitizenId?: string;
    customerPhoneNumber?: string;
    customerEmail?: string;
    customerAddress?: string;
    customerFacebookUrl?: string;
    customerLineId?: string;
    productBrand?: string;
    productModel?: string;
    productPrice?: number;
    downPercentage?: number;
    savingStartAmount?: number;
    savingAmount?: number;
    savingFrequency: DownSavingUpdateRequest.savingFrequency;
    downAmount?: number;
    balanceAmount?: number;
    reserveAmount?: number;
    discountAmount?: number;
    fineAmount?: number;
    promotionName?: string;
    promotionDiscountAmount?: number;
    promotionDiscountInstallmentAmount?: number;
};
export namespace DownSavingUpdateRequest {
    export enum savingFrequency {
        DAILY = 'DAILY',
        THREE_DAYS = 'THREE_DAYS',
        WEEKLY = 'WEEKLY',
        BIWEEKLY = 'BIWEEKLY',
        MONTHLY = 'MONTHLY',
    }
}

